import { render, staticRenderFns } from "./chipLottery.vue?vue&type=template&id=0a5d374a&scoped=true&"
import script from "./chipLottery.vue?vue&type=script&lang=js&"
export * from "./chipLottery.vue?vue&type=script&lang=js&"
import style0 from "./chipLottery.vue?vue&type=style&index=0&id=0a5d374a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d374a",
  null
  
)

export default component.exports